import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "box-column full-height overflow-auto" }
const _hoisted_2 = { class: "header flex full-width justify-between text-overline text-uppercase q-pa-md no-highlight" }
const _hoisted_3 = { class: "ellipsis" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = {
  key: 0,
  class: "content q-pa-md overflow-auto fadeinAnimation"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { computed, ref, PropType, watch } from "vue";
  import { useElementVisibility } from '@vueuse/core'

  import { useProposalStore } from "src/stores/proposal-store";
  
  import { LoanStatusType_Enum } from "src/types/enums/index";
  import { LoanApplication } from "src/types/loan-application/index";
  import { QuickQuote } from "src/types/quote/index";

  import ApplicationOverview from "src/components/customer/proposal/ApplicationOverview.vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PipelineColumn',
  props: {
    name: {
      type: String,
      default: ""
    },
    applications: {
      type: Array as PropType<LoanApplication[]>,
      default: []
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const proposalStore = useProposalStore();

  const props = __props

  watch(() => props.collapsed, () => {
    isCollapsed.value = props.collapsed;
  })

  const isCollapsed = ref(JSON.parse(JSON.stringify(props.collapsed)))
  watch(() => isCollapsed.value, (newVal: boolean, oldVal: boolean) => {
    if (!newVal && oldVal) {
      setTimeout(() => { finishedExpanding.value = true }, 310)
    }
    if (!oldVal && newVal) {
      finishedExpanding.value = false;
    }
  })

  const target = ref(null)
  const targetIsVisible = useElementVisibility(target)

  const toShow = ref(10);
  const finishedExpanding = ref(props.collapsed ? false : true)

  watch(() => targetIsVisible.value, (newVal: boolean, oldVal: boolean) => {
    if (!oldVal && newVal) {
      toShow.value = toShow.value + 10;
    }
  })

  const style = computed(() => {
    return isCollapsed.value ?
      {
        width: "50px",
        "min-width": "50px",
        "background-color": "#f1f5f9"
      }
      : {
        "-webkit-transition": "width 1s ease-in-out",
        "-moz-transition": "width 1s ease-in-out",
        "-o-transition": "width 1s ease-in-out",
        "transition": "width 1s ease-in-out",
        width: "320px",
        "min-width": "320px",
        "background-color": "#f1f5f9"
      }
  })

return (_ctx: any,_cache: any) => {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    class: _normalizeClass(["q-mr-sm pipeline-column no-shadow", isCollapsed.value ? '' : 'expanded']),
    bordered: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(__props.name), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_badge, {
              rounded: "",
              color: "grey-4",
              class: "text-dark text-overline"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.applications.length), 1)
              ]),
              _: 1
            })
          ])
        ]),
        (!isCollapsed.value && finishedExpanding.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!__props.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.applications.slice(0, toShow.value), (app, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: __props.name+app.brokerReference,
                        class: "q-pb-sm"
                      }, [
                        _createVNode(ApplicationOverview, { application: app }, null, 8, ["application"])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_q_card, { style: {"height":"110px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "q-pa-sm" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_item, {
                              dense: "",
                              class: "q-pa-none"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_skeleton, {
                                      type: "QAvatar",
                                      width: "60px",
                                      height: "60px"
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_item_section, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_skeleton, {
                                      type: "text",
                                      width: "100px"
                                    }),
                                    _createVNode(_component_q_skeleton, {
                                      type: "text",
                                      width: "90px"
                                    }),
                                    _createVNode(_component_q_skeleton, {
                                      type: "text",
                                      width: "50px"
                                    }),
                                    _createVNode(_component_q_skeleton, {
                                      type: "text",
                                      width: "120px"
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])),
              _createElementVNode("div", {
                ref_key: "target",
                ref: target,
                class: "q-pa-md"
              }, null, 512)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})